import { render } from "./MentionList.vue?vue&type=template&id=66d38928&scoped=true"
import script from "./MentionList.vue?vue&type=script&lang=ts"
export * from "./MentionList.vue?vue&type=script&lang=ts"

import "./MentionList.vue?vue&type=style&index=0&id=66d38928&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-66d38928"

export default script